export default {};
export const API_URL = "https://api.groupblogger.net/api";
export const STRIPE_KEY = "pk_test_APZNs1fORyroy3mkHdO0tI5x";
export const mainGroupId = 3;



// WEBPACK FOOTER //
// ./src/common/config.js